/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlogEntryImageId
 */
export interface BlogEntryImageId {
    /**
     * 
     * @type {string}
     * @memberof BlogEntryImageId
     */
    id?: string;
}

/**
 * Check if a given object implements the BlogEntryImageId interface.
 */
export function instanceOfBlogEntryImageId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BlogEntryImageIdFromJSON(json: any): BlogEntryImageId {
    return BlogEntryImageIdFromJSONTyped(json, false);
}

export function BlogEntryImageIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlogEntryImageId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function BlogEntryImageIdToJSON(value?: BlogEntryImageId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

